// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { applyGiftCode, checkMission, claimAccumulatedSpunReward, claimPointReward, claimServerSpunMilestone, createChampionPrediction, createMatchPrediction, createTopScorerPrediction, getConfig, getCurrentGlobalSpun, getGiftcodeStatus, getLeaderboard, getMatchPredictions, getParam, getPointRewardUserCounts, getReceivedMiniSpinCells, getRewardToFcoHistory, getState, getUserLoginFake, getUserMe, miniSpin, type Options, spin } from '../sdk.gen';
import type { ApplyGiftCodeData, ApplyGiftCodeResponse, CheckMissionData, CheckMissionResponse, ClaimAccumulatedSpunRewardData, ClaimAccumulatedSpunRewardResponse, ClaimPointRewardData, ClaimPointRewardResponse, ClaimServerSpunMilestoneData, ClaimServerSpunMilestoneResponse, CreateChampionPredictionData, CreateChampionPredictionResponse, CreateMatchPredictionData, CreateMatchPredictionResponse, CreateTopScorerPredictionData, CreateTopScorerPredictionResponse, GetConfigData, GetConfigResponse, GetCurrentGlobalSpunData, GetCurrentGlobalSpunResponse, GetGiftcodeStatusData, GetGiftcodeStatusResponse, GetLeaderboardData, GetLeaderboardResponse, GetMatchPredictionsData, GetMatchPredictionsResponse, GetParamData, GetParamResponse, GetPointRewardUserCountsData, GetPointRewardUserCountsResponse, GetReceivedMiniSpinCellsData, GetReceivedMiniSpinCellsResponse, GetRewardToFcoHistoryData, GetRewardToFcoHistoryResponse, GetStateData, GetStateResponse, GetUserLoginFakeData, GetUserMeData, GetUserMeResponse, MiniSpinData, MiniSpinResponse, SpinData, SpinResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getParamQueryKey = (options: Options<GetParamData>) => createQueryKey('getParam', options);

/**
 * Common params
 */
export const getParamOptions = (options: Options<GetParamData>) => queryOptions<GetParamResponse, DefaultError, GetParamResponse, ReturnType<typeof getParamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParamQueryKey(options)
});

export const getConfigQueryKey = (options?: Options<GetConfigData>) => createQueryKey('getConfig', options);

export const getConfigOptions = (options?: Options<GetConfigData>) => queryOptions<GetConfigResponse, DefaultError, GetConfigResponse, ReturnType<typeof getConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConfigQueryKey(options)
});

export const getGiftcodeStatusQueryKey = (options?: Options<GetGiftcodeStatusData>) => createQueryKey('getGiftcodeStatus', options);

export const getGiftcodeStatusOptions = (options?: Options<GetGiftcodeStatusData>) => queryOptions<GetGiftcodeStatusResponse, DefaultError, GetGiftcodeStatusResponse, ReturnType<typeof getGiftcodeStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftcodeStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftcodeStatusQueryKey(options)
});

export const applyGiftCodeMutation = (options?: Partial<Options<ApplyGiftCodeData>>): UseMutationOptions<ApplyGiftCodeResponse, DefaultError, Options<ApplyGiftCodeData>> => {
    const mutationOptions: UseMutationOptions<ApplyGiftCodeResponse, DefaultError, Options<ApplyGiftCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await applyGiftCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLeaderboardQueryKey = (options?: Options<GetLeaderboardData>) => createQueryKey('getLeaderboard', options);

export const getLeaderboardOptions = (options?: Options<GetLeaderboardData>) => queryOptions<GetLeaderboardResponse, DefaultError, GetLeaderboardResponse, ReturnType<typeof getLeaderboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLeaderboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLeaderboardQueryKey(options)
});

export const getUserLoginFakeQueryKey = (options?: Options<GetUserLoginFakeData>) => createQueryKey('getUserLoginFake', options);

export const getUserLoginFakeOptions = (options?: Options<GetUserLoginFakeData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserLoginFakeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserLoginFake({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserLoginFakeQueryKey(options)
});

export const getUserMeQueryKey = (options?: Options<GetUserMeData>) => createQueryKey('getUserMe', options);

/**
 * Get user session
 */
export const getUserMeOptions = (options?: Options<GetUserMeData>) => queryOptions<GetUserMeResponse, DefaultError, GetUserMeResponse, ReturnType<typeof getUserMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserMeQueryKey(options)
});

export const getStateQueryKey = (options?: Options<GetStateData>) => createQueryKey('getState', options);

export const getStateOptions = (options?: Options<GetStateData>) => queryOptions<GetStateResponse, DefaultError, GetStateResponse, ReturnType<typeof getStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStateQueryKey(options)
});

export const checkMissionMutation = (options?: Partial<Options<CheckMissionData>>): UseMutationOptions<CheckMissionResponse, DefaultError, Options<CheckMissionData>> => {
    const mutationOptions: UseMutationOptions<CheckMissionResponse, DefaultError, Options<CheckMissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkMission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const spinMutation = (options?: Partial<Options<SpinData>>): UseMutationOptions<SpinResponse, DefaultError, Options<SpinData>> => {
    const mutationOptions: UseMutationOptions<SpinResponse, DefaultError, Options<SpinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await spin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const miniSpinMutation = (options?: Partial<Options<MiniSpinData>>): UseMutationOptions<MiniSpinResponse, DefaultError, Options<MiniSpinData>> => {
    const mutationOptions: UseMutationOptions<MiniSpinResponse, DefaultError, Options<MiniSpinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await miniSpin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getReceivedMiniSpinCellsQueryKey = (options?: Options<GetReceivedMiniSpinCellsData>) => createQueryKey('getReceivedMiniSpinCells', options);

export const getReceivedMiniSpinCellsOptions = (options?: Options<GetReceivedMiniSpinCellsData>) => queryOptions<GetReceivedMiniSpinCellsResponse, DefaultError, GetReceivedMiniSpinCellsResponse, ReturnType<typeof getReceivedMiniSpinCellsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReceivedMiniSpinCells({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReceivedMiniSpinCellsQueryKey(options)
});

export const claimAccumulatedSpunRewardMutation = (options?: Partial<Options<ClaimAccumulatedSpunRewardData>>): UseMutationOptions<ClaimAccumulatedSpunRewardResponse, DefaultError, Options<ClaimAccumulatedSpunRewardData>> => {
    const mutationOptions: UseMutationOptions<ClaimAccumulatedSpunRewardResponse, DefaultError, Options<ClaimAccumulatedSpunRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await claimAccumulatedSpunReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRewardToFcoHistoryQueryKey = (options?: Options<GetRewardToFcoHistoryData>) => createQueryKey('getRewardToFcoHistory', options);

export const getRewardToFcoHistoryOptions = (options?: Options<GetRewardToFcoHistoryData>) => queryOptions<GetRewardToFcoHistoryResponse, DefaultError, GetRewardToFcoHistoryResponse, ReturnType<typeof getRewardToFcoHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRewardToFcoHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRewardToFcoHistoryQueryKey(options)
});

export const createChampionPredictionMutation = (options?: Partial<Options<CreateChampionPredictionData>>): UseMutationOptions<CreateChampionPredictionResponse, DefaultError, Options<CreateChampionPredictionData>> => {
    const mutationOptions: UseMutationOptions<CreateChampionPredictionResponse, DefaultError, Options<CreateChampionPredictionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createChampionPrediction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createTopScorerPredictionMutation = (options?: Partial<Options<CreateTopScorerPredictionData>>): UseMutationOptions<CreateTopScorerPredictionResponse, DefaultError, Options<CreateTopScorerPredictionData>> => {
    const mutationOptions: UseMutationOptions<CreateTopScorerPredictionResponse, DefaultError, Options<CreateTopScorerPredictionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTopScorerPrediction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMatchPredictionsQueryKey = (options?: Options<GetMatchPredictionsData>) => createQueryKey('getMatchPredictions', options);

export const getMatchPredictionsOptions = (options?: Options<GetMatchPredictionsData>) => queryOptions<GetMatchPredictionsResponse, DefaultError, GetMatchPredictionsResponse, ReturnType<typeof getMatchPredictionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMatchPredictions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMatchPredictionsQueryKey(options)
});

export const createMatchPredictionMutation = (options?: Partial<Options<CreateMatchPredictionData>>): UseMutationOptions<CreateMatchPredictionResponse, DefaultError, Options<CreateMatchPredictionData>> => {
    const mutationOptions: UseMutationOptions<CreateMatchPredictionResponse, DefaultError, Options<CreateMatchPredictionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMatchPrediction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPointRewardUserCountsQueryKey = (options?: Options<GetPointRewardUserCountsData>) => createQueryKey('getPointRewardUserCounts', options);

export const getPointRewardUserCountsOptions = (options?: Options<GetPointRewardUserCountsData>) => queryOptions<GetPointRewardUserCountsResponse, DefaultError, GetPointRewardUserCountsResponse, ReturnType<typeof getPointRewardUserCountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointRewardUserCounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointRewardUserCountsQueryKey(options)
});

export const claimPointRewardMutation = (options?: Partial<Options<ClaimPointRewardData>>): UseMutationOptions<ClaimPointRewardResponse, DefaultError, Options<ClaimPointRewardData>> => {
    const mutationOptions: UseMutationOptions<ClaimPointRewardResponse, DefaultError, Options<ClaimPointRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await claimPointReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCurrentGlobalSpunQueryKey = (options?: Options<GetCurrentGlobalSpunData>) => createQueryKey('getCurrentGlobalSpun', options);

export const getCurrentGlobalSpunOptions = (options?: Options<GetCurrentGlobalSpunData>) => queryOptions<GetCurrentGlobalSpunResponse, DefaultError, GetCurrentGlobalSpunResponse, ReturnType<typeof getCurrentGlobalSpunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCurrentGlobalSpun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentGlobalSpunQueryKey(options)
});

export const claimServerSpunMilestoneMutation = (options?: Partial<Options<ClaimServerSpunMilestoneData>>): UseMutationOptions<ClaimServerSpunMilestoneResponse, DefaultError, Options<ClaimServerSpunMilestoneData>> => {
    const mutationOptions: UseMutationOptions<ClaimServerSpunMilestoneResponse, DefaultError, Options<ClaimServerSpunMilestoneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await claimServerSpunMilestone({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
